// src/ProtectedRoute.tsx
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../store/store';

const allowedRoles = ['ADMIN', 'SUPERADMIN'];

const ProtectedRoute: React.FC = () => {
  const user = useSelector((state: RootState) => state.user.user);
  console.log('user', user);
  return user && allowedRoles.includes(user.role) ? (
    <Outlet />
  ) : (
    <Navigate to="/login" />
  );
};

export default ProtectedRoute;
